import React from 'react';

import * as Styled from './styled';

interface IPipsTradesValues {
  value?: string | number;
  hasTitle?: boolean;
}

const days14 = 14;
const day1 = 1;

export const RemainingTime: React.FC<IPipsTradesValues> = ({
  value,
  hasTitle,
}) => {
  const currentValue = value as number;
  const isPositive = currentValue > days14;
  const isProgress = currentValue <= days14 && currentValue > day1;
  const isNegative = currentValue === day1;

  return (
    <React.Fragment>
      <Styled.Value
        $isPositive={isPositive}
        $isNegative={isNegative}
        $isProgress={isProgress}
        $hasBg
      >
        {currentValue < day1 ? 'Completed' : currentValue}{' '}
        {currentValue < day1 ? '' : currentValue === 1 ? 'day' : 'days'}
      </Styled.Value>
      {hasTitle && <Styled.Title>Remaining</Styled.Title>}
    </React.Fragment>
  );
};

export const GoalReached: React.FC<IPipsTradesValues> = ({
  value,
  hasTitle,
}) => {
  return (
    <React.Fragment>
      <Styled.GoalReachedValue>
        {(value as number)?.toFixed(0)}%
      </Styled.GoalReachedValue>
      {hasTitle && <Styled.Title>Goal Reached</Styled.Title>}
    </React.Fragment>
  );
};
